import { render, staticRenderFns } from "./StorageSpaceTable.vue?vue&type=template&id=4dbfb07c&"
import script from "./StorageSpaceTable.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports